/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodProfileSelectCommodityPicker: "good-profile-select-commodity-picker",
  goodProfileSelectCommoditySearch: "good-profile-select-commodity-search",
} as const;
